module.exports = __webpack_public_path__ + "img/ico-share02.e651cb30.svg";